import React from "react";
import styled, { css } from "styled-components";

// type Props = {
//   id?: string;
//   className?: string;
//   style?: any;
//   destructive?: boolean;
//   disabled?: boolean;
//   size?: 'small' | 'large';
//   startIcon?: ReactNode;
//   type?: 'submit' | 'button' | 'reset';
//   variant?: 'primary' | 'secondary' | 'tertiary';
//   onClick?: (event: MouseEvent) => void;
//   onMouseDown?: (event: MouseEvent) => void;
// };

const Button = ({
  children,
  id,
  className,
  style,
  destructive,
  disabled,
  size = "large",
  startIcon,
  type = "submit",
  variant = "primary",
  onClick,
  onMouseDown
}) => {
  const props = {
    id,
    className,
    style,
    destructive,
    disabled,
    isChildNodeString: typeof children === "string",
    size,
    startIcon,
    type,
    variant,
    onClick,
    onMouseDown
  };

  return (
    <StyledButton {...props}>
      {startIcon}
      {children}
    </StyledButton>
  );
};

const baseStyles = css`
  height: ${(p) => (p.size === "small" ? "28px" : "36px")};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 8px 16px 8px;
  border: none;
  border-radius: 4px;
  cursor: pointer;

  &:focus {
    outline: none;
  }
`;

const StyledButton = styled.button`
  ${baseStyles}

  ${(p) =>
    p.startIcon &&
    css`
      & > :first-child {
        margin: -0.5px 5px 0.5px 0;
      }
    `}

  ${(p) =>
    p.isChildNodeString &&
    css`
      font-size: 14px;
      font-weight: 700;
      line-height: 20px;
    `}

  ${(p) =>
    p.variant === "primary" &&
    css`
      color: #FFFFFF;
      background-color: #0F9BF0;

      &:hover {
        background-color: #0892E5;
      }

      &:active {
        background-color: #0584D7;
      }

      ${(p) =>
        p.destructive &&
        css`
          background-color: #E5084A;

          &:hover {
            background-color: #C7053F;
          }

          &:active {
            background-color: #C7053F;
          }
        `}

      &:disabled {
        color: #FFFFFF;
        background-color: #D1D5DD;
        cursor: not-allowed;
      }
    `}

  ${(p) =>
    p.variant === "secondary" &&
    css`
      color: #364866;
      background-color: #FFFFFF;
      border: 1px solid #0F9BF0;

      &:hover {
        color: #0892E5;
      }

      &:active {
        color: #0584D7;
      }

      ${(p) =>
        p.destructive &&
        css`
          color: #E5084A;
          border-color: #E5084A;

          &:hover {
            color: #C7053F;
            border-color: #C7053F;
          }

          &:active {
            color: #C7053F;
            border-color: #C7053F;
          }
        `}

      &:disabled {
        color: #A6AEBC;
        background-color: #FFFFFF;
        border-color: #F1F2F4;
        cursor: not-allowed;
      }
    `}

  ${(p) =>
    p.variant === "tertiary" &&
    css`
      color: #364866;
      background-color: #FFFFFF;
      border: 1px solid #C9CED6;

      &:hover {
        color: #0892E5;
      }

      &:active {
        color: #0584D7;
      }

      ${(p) =>
        p.destructive &&
        css`
          &:hover {
            color: #E5084A;
          }

          &:active {
            color: #C7053F;
          }
        `}

      &:disabled {
        color: #A6AEBC;
        background-color: #FFFFFF;
        border-color: #F1F2F4;
        cursor: not-allowed;
      }
    `}
`;

export default Button;
